"use client";

import React from "react";
import "./Testimonials.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { faQuoteLeft, faStar } from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarRegular } from "@fortawesome/free-regular-svg-icons";

import "swiper/css";
import "swiper/css/pagination";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CommonHeading from "../../Common_Components/Common_Heading/Common_Heading";

const testimonials = [
  {
    name: "Rajesh Kumar",
    role: "Healthcare professional, Maharashtra",
    review:
      "Kaumodaki provided me with excellent guidance throughout my overseas job placement. The entire process was transparent and hassle-free. Highly recommended!",

    rating: 5,
  },
  {
    name: "Priya Singh",
    role: "IT Professional, Canada",
    review:
      "The team was very professional and supportive. They handled all documentation and visa process efficiently. I'm now successfully working abroad!",

    rating: 5,
  },
  {
    name: "Amit Patel",
    role: "Engineer, Saudi Arabia",
    review:
      "Best recruitment agency I've worked with. They understood my requirements perfectly and matched me with the ideal job. Simply outstanding service!",

    rating: 4.5,
  },
  {
    name: "Amit Patel",
    role: "Engineer, Saudi Arabia",
    review:
      "Best recruitment agency I've worked with. They understood my requirements perfectly and matched me with the ideal job. Simply outstanding service!",

    rating: 4.5,
  },
];

const Testimonials = () => {
  return (
    <section className="testimonials_section container">
      <CommonHeading title="What Client Says" />

      <Swiper
        modules={[Autoplay, Pagination]}
        spaceBetween={20}
        slidesPerView={1}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          480: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        }}
        className="testimonials_swiper"
      >
        {testimonials.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="testimonial_card">
              <div className="testimonial_quote">
                <FontAwesomeIcon icon={faQuoteLeft} />
              </div>

              <div className="testimonial_stars">
                {[1, 2, 3, 4, 5].map((star) => (
                  <FontAwesomeIcon
                    key={star}
                    icon={star <= item.rating ? faStar : faStarRegular}
                    className={star <= item.rating ? "active" : ""}
                  />
                ))}
              </div>

              <p className="testimonial_review">“{item.review}”</p>

              <div className="testimonial_user">
                <div>
                  <h4>{item.name}</h4>
                  <span>{item.role}</span>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Testimonials;
